module.exports = __webpack_public_path__ + "img/ylserve.ecd74e68.png";